import { render, staticRenderFns } from "./crudWaist.vue?vue&type=template&id=08ed84ca"
import script from "./crudWaist.vue?vue&type=script&lang=js"
export * from "./crudWaist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports